<div
  style="
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    padding-top: 350px;
    position: fixed;
    left: 0;
    top: 0;
    text-align: center;
    z-index: 999999 !important;
  "
>
  <nz-spin nzSimple nzTip="正在上传..."></nz-spin>
</div>
